import React from "react";

import logoLight from "../../../images/logo-segfy-light.svg";
import {
  Panel,
  Glow,
  Logo,
  Middle,
  Badge,
  Title,
  Description,
  PerkList,
  Perk,
  Footer,
} from "./styles";

const PERKS = [
  "Multicálculo em segundos",
  "Gestão de apólices, sinistros e financeiro",
  "Suporte humanizado de verdade",
];

const BrandPanel: React.FC = () => {
  return (
    <Panel>
      <Glow variant="top" />
      <Glow variant="bottom" />

      <Logo src={logoLight} alt="Segfy" />

      <Middle>
        <Badge>
          <span />
          Plataforma 100% online
        </Badge>
        <Title>
          Sua corretora inteira <span>em uma tela só.</span>
        </Title>
        <Description>
          Multicálculo, gestão e financeiro. Acesse de onde estiver, sem
          instalação.
        </Description>
        <PerkList>
          {PERKS.map((perk) => (
            <Perk key={perk}>
              <span>✓</span>
              {perk}
            </Perk>
          ))}
        </PerkList>
      </Middle>

      <Footer>Segfy Tecnologia S/A · © 2026 Segfy ®</Footer>
    </Panel>
  );
};

export default BrandPanel;
